export const getError = (error: any): string => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.error
  )
    return error.response.data.error.toString();
  else if (error && error.data && error.data.error)
    return error.data.error.toString();
  else if (error && error.data) return error.data.toString();
  else return error.toString();
};
